module.exports = __webpack_public_path__ + "340ba116896f5dde43c93544c3672069.pdf";